import { render, staticRenderFns } from "./SelectBoolean.vue?vue&type=template&id=2810d131&"
import script from "./SelectBoolean.vue?vue&type=script&lang=js&"
export * from "./SelectBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports